import { Navigate, useLocation } from "react-router-dom-v5-compat";

type Props = {
  toPathname: string;
};

export const NavigateKeepingSearch: React.FC<Props> = ({ toPathname }) => {
  const location = useLocation();

  return <Navigate to={{ pathname: toPathname, search: location.search }} replace />;
};
